<!--
 * @Description: 今日收入
 * @Date: 2019-10-29 10:21:46
 * @LastEditors: Ji Yinghao
 * @LastEditTime: 2019-10-29 18:53:04
 -->

<template>
<div >
  <v-row justify="center">
    <v-dialog v-model="dialog" max-width="500px">
      <v-card>
        <v-card-title>
          <span> 今日收入 </span>
          <v-spacer></v-spacer>
          <v-menu bottom left>
            <template v-slot:activator="{ on }">
              <v-btn icon v-on="on" @click="()=>{dialog = false}">
                <v-icon>close</v-icon>
              </v-btn>
            </template>
            <!-- <v-list>
              <v-list-item v-for="(item, i) in 5" :key="i" @click="() => {}">
                <v-list-item-title>{{ item }}</v-list-item-title>
              </v-list-item>
            </v-list> -->
          </v-menu>
        </v-card-title>
        <v-card-text class="black--text" id="cumulative__">
          <v-list-item two-line v-for="(item, index) in data" :key="index" >
            <v-list-item-content>
              <v-list-item-subtitle>{{ item.create_time | time }}</v-list-item-subtitle>
              <v-list-item-title>
                <v-chip
                    class="ma-2"
                    color="black"
                    text-color="black"
                    small
                    outlined
                  >
                  {{ (item.fee/100).toFixed(2) }} 元
                </v-chip>
              </v-list-item-title>
            </v-list-item-content>
           </v-list-item>
           <p v-if="data.length == 0"> 暂无记录... </p>
        </v-card-text>
        <v-card-actions>
          <!-- <v-btn color="primary" text @click="dialog = false">Close</v-btn> -->
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialog: false,
      data:[]
    };
  },
  methods: {
    info(state,data) {
      this.dialog = state;
      this.data = data.today_info
    }
  }
};
</script>

<style>
#cumulative__ .v-list-item__content{
  padding-bottom: 0;
}
</style>